import { BankType, NegotiationOptionAlternativeType } from '../generated/graphql';

const {
  BalanceBehind,
  MinPayment,
  Behind_30: Behind30,
  Behind_60: Behind60,
} = NegotiationOptionAlternativeType;
export const getNegotiationOptionAlternativeTypeLabel = (
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  type: NegotiationOptionAlternativeType, _bank: BankType,
) => {
  switch (type) {
    case BalanceBehind: return 'Saldo en mora';
    case MinPayment: return 'Pago mínimo';
    case Behind30: return 'Pago parcial 1';
    case Behind60: return 'Pago parcial 2';
    default: return type;
  }
};
